var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3285_3688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3285_3688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5026V15.8359L4.16667 10.8359L2.5 5.83594V4.16927H13.0833L14.2917 0.835938L16.25 1.54427L15.2917 4.16927H17.5V5.83594L15.8333 10.8359L17.5 15.8359V17.5026H2.5ZM9.16667 14.1693H10.8333V11.6693H13.3333V10.0026H10.8333V7.5026H9.16667V10.0026H6.66667V11.6693H9.16667V14.1693ZM4.25 15.8359H15.75L14.0833 10.8359L15.75 5.83594H4.25L5.91667 10.8359L4.25 15.8359Z",
    fill: "#F5D447"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyIcon);
export default __webpack_public_path__ + "static/media/pharmacy-icon.4497b576bbcbc25c013efbb803c60ea8.svg";
export { ForwardRef as ReactComponent };